




import { observable, action, computed } from 'mobx';
import { getIDs } from '../components/Matrix/functions/getID';
import { IOrgStageCoordsGetterOutput } from '../components/Matrix/functions/getOrgStages-1';
import { RootStore } from './RootStore';





export class DatasetStore {

    rootStore = RootStore;
    constructor(rootStore: any) {
        this.rootStore = rootStore
    }

    @observable current: IOrgStageCoordsGetterOutput | null = null

    @computed get loaded(){
        return !!this.current
    }

    @action set = (d: IOrgStageCoordsGetterOutput) => this.current = d


}